/* eslint-disable max-len */

const demoData = [
  'Please use this feature only to complete your certification or to showcase the game to your potential clients',
  'One account is able to only run one game at a time. This demo booking system designed so you dont have to buy games in order to run demos for your clients or to complete your certification program',
  'In order for this to work, youll need to respect the access. Only log into the platform in your scheduled time (even if you only need to practice). You will have 2.5 hour slots so you can do a few practice runs before you get started.',
  'If you find this to be too tedious, you can also request for a dedicated demo account at $50 per month.',
];
export default demoData;
